import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageContainer from "../Layout/PageContainer";
import PayoutView from "./View";
import payoutService from "../../redux/services/payout.service";

export default function PayoutViewIndex() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [payoutDetail, setPayoutDetail] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!id || !/\d+/.test(id)) {
            navigate(-1);
            return;
        }

        const fetchPayoutDetails = async () => {
            try {
                const response = await payoutService.getPayoutDetails(id);
                if (response && response.data && response.data.data) {
                    setPayoutDetail(response.data.data);
                } else {
                    toast.error("Unable to find payout details.");
                    navigate(-1);
                }
            } catch (error) {
                console.error("Error fetching payout details:", error);
                toast.error(error?.response?.data?.message || "Failed to fetch payout details.");
                navigate(-1);
            } finally {
                setLoading(false);
            }
        };

        fetchPayoutDetails();
    }, [id, navigate]);

    const refetchPayoutDetails = async () => {
        try {
            const response = await payoutService.getPayoutDetails(id);
            if (response && response.data && response.data.data) {
                setPayoutDetail(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching payout details:", error);
        }
    };

    return (
        <PageContainer
            pageTitleIcon="pe-7s-shopbag icon-gradient bg-plum-plate"
            pageHeading="Payout Details"
            pageSubTitle="Detailed view of the payout and reservation information."
        >
            {loading ? (
                <div>Loading...</div>
            ) : (
                <PayoutView payoutDetail={payoutDetail} onUpdated={refetchPayoutDetails} />
            )}
        </PageContainer>
    );
}
